import { render } from "./Collection-frame-options.vue?vue&type=template&id=15458cd4&scoped=true"
import script from "./Collection-frame-options.vue?vue&type=script&lang=js"
export * from "./Collection-frame-options.vue?vue&type=script&lang=js"

import "./Collection-frame-options.vue?vue&type=style&index=0&id=15458cd4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15458cd4"]])

export default __exports__